import Reflux from "reflux";

import _ from "lodash";
import UserService from "../service/UserService";
import session from "../config/session";

var AssetActions = Reflux.createActions({
  createElement: {},
  createElements: {},
  createElementFromUploading: {},
  uploadFiles: {},
  completeAssetUpload: {},
  deleteAssets: {},

  createFolder: { asyncResult: true, children: ["complete", "fail"] },
  updateFolder: { asyncResult: true, children: ["complete", "fail"] },
  moveToFolder: { asyncResult: true, children: ["complete", "fail"] },
  deleteFolder: { asyncResult: true, children: ["complete", "fail"] },
});

AssetActions.createFolder.listen(function (folder) {
  UserService.createFolder(session.userId, folder.name).then(this.complete).catch(this.fail);
});

AssetActions.updateFolder.listen(function (folder, data) {
  var folderUpdate = _.clone(folder);
  if (_.has(data, "name") && !_.isEmpty(data.name)) {
    folderUpdate.name = data.name;

    UserService.updateFolder(session.userId, folder.folder_id, folderUpdate)
      .then(this.complete)
      .catch(this.fail);
  }
});

AssetActions.moveToFolder.listen(function (assets, folder) {
  var assetIds = _.map(assets, "asset_id"); //just get ids to send
  var folderId = folder != null ? folder.folder_id : null;

  UserService.addAssetsToFolder(session.userId, folderId, assetIds)
    .then(this.complete)
    .catch(this.fail);
});

AssetActions.deleteFolder.listen(function (folder) {
  UserService.deleteFolder(session.userId, folder.folder_id).then(this.complete).catch(this.fail);
});

export default AssetActions;
